// SegmentsList.tsx - Windowed Studio list wrapper

import React from 'react';
import { Segment } from './types';
import StudioList, { StudioTab } from './StudioList';

interface SegmentsListProps {
  segments: Segment[];
  activeSegment: string | null;
  activeComboId: string | null;
  isLooping: boolean;
  editingSegment: string | null;
  segmentNameInputRef: React.RefObject<HTMLInputElement | null>;
  onSaveSegmentName: (segmentId: string, newName: string) => void;
  onStartEditingSegment: (segmentId: string) => void;
  onPlaySegment: (segmentId: string) => void;
  onSelectCombo: (comboId: string) => void;
  onToggleSegmentLearned: (segmentId: string) => void;
  onToggleSegmentDisabled: (segmentId: string) => void;
  onDeleteSegment: (segmentId: string) => void;
  onBatchToggleDisabledSelected: (tab: StudioTab) => void;
  onBatchDeleteSelected: (tab: StudioTab) => void;
  onCreateCombo: () => void;
  onDuplicateCombo: (comboId: string) => void;
  onDeleteCombo: (comboId: string) => void;
  activeTab: StudioTab;
  onActiveTabChange: (tab: StudioTab) => void;
  videoSrc?: string | null;
  onToggleAllLearned?: (learned: boolean, tab: StudioTab) => void;
  showTabs?: boolean;
  headerControl?: React.ReactNode;
  playingSegmentId?: string | null;
  onCancelEditingSegment?: () => void;
}

const SegmentsList: React.FC<SegmentsListProps> = (props) => (
  <StudioList {...props} variant="windowed" />
);

export default SegmentsList;
